<template>
    <v-card>
      <v-card-title
        class="headline"
        primary-title
      >
        {{ title }}
      </v-card-title>

      <v-card-text v-html="text" />

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          data-cy="cancelConfirmationDialog"
          contained
          color="default"
          text
          @click="onCancel"
        >
          {{ cancelBtnTxt }}
        </v-btn>

        <v-btn
          :loading="loadingSubmitBtn"
          contained
          color="error"
          text
          @click="onSubmit"
        >
          {{ submitBtnTxt }}
        </v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>


export default {
  name: 'ConfirmationDialog',
  props: {
    show: Boolean,
    title: String,
    text: String,
    submitBtnTxt: String,
    cancelBtnTxt: String,
    loadingSubmitBtn: Boolean
  },
  methods: {
    onCancel () {
      this.$emit('onCancel');
    },
    onSubmit () {
      this.$emit('onSubmit');
    }
  }
}
</script>